"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockCodeEditor = exports.BlockCode = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _immer = _interopRequireDefault(require("immer"));

var _recoil = require("recoil");

var _RecoilStates = require("../../contexts/RecoilStates");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @param {{block: BlockCode}} param0
 * @returns
 */
var BlockCode = function BlockCode(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

  var block = _ref.block;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var code = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.code) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.code;
  return __jsx(_react["default"].Fragment, null, code.trim().length > 0 ? __jsx(_react2.Box, {
    minH: "10px",
    minW: "10px",
    border: "1px solid #ccc",
    pointerEvents: "none",
    dangerouslySetInnerHTML: {
      __html: code
    }
  }) : __jsx(_react2.Text, {
    color: "rgba(0,0,0,.87)"
  }, "Block code vide"));
};

exports.BlockCode = BlockCode;

/**
 * @param {{
 * block: BlockCode,
 * onUpdate: (block: Block) => {}
 * }} param0
 * @returns
 */
var BlockCodeEditor = function BlockCodeEditor(_ref2) {
  var _block$content$intl$l3, _block$content$intl$l4, _block$content$intl$d2;

  var block = _ref2.block,
      onUpdate = _ref2.onUpdate;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var ref = (0, _react.useRef)(null);
  var code = (_block$content$intl$l3 = (_block$content$intl$l4 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l4.code) != null ? _block$content$intl$l3 : (_block$content$intl$d2 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d2.code;

  var onChange = function onChange(event) {
    var value = event.target.value;
    onUpdate((0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          code: ""
        };
      }

      draft.content.intl[language.key].code = value;
    }));
  };

  (0, _react.useEffect)(function () {
    ref.current.focus();
  }, []);
  return __jsx(_react2.Textarea, {
    ref: ref,
    px: "4",
    py: "0",
    width: "100%",
    minWidth: "100px",
    height: "100%",
    onChange: onChange,
    value: code,
    whiteSpace: "pre-wrap",
    color: "gray.700",
    backgroundColor: "white",
    resize: "none"
  });
};

exports.BlockCodeEditor = BlockCodeEditor;